module.exports = __webpack_public_path__ + "img/astro10.8fe7d14b.jpg";